Controller = App.loadClass 'core::Angular/Controller'

class exports.SelectZonesController extends Controller
    constructor: (@scope, @transitions, @pgis, @validation, @zones) ->
        # prevent errors when refreshing or navigating directly to this step
        if @validation.canContinue()
            @scope.validate = @validate
            @validation.setStepScope(@scope)
            # set field data
            @scope.field_data = @validation.getFieldData()
            # set function on scope
            @scope.toggleZone = @toggleZone
            @scope.buttonDisabled = @buttonDisabled
            # if year is set then we are not editing
            if @scope.field_data.year?
                @scope.field_data.editing = null

            @validation.setBackButtonDisable(@scope.field_data, 'zone-add')

            # Cleanup the map if we're navigating away from the definition process
            @transitionStart = @transitions.onStart {}, ($transition) =>
                if not _.startsWith($transition.to().name, 'grower.fields-define')
                    # clear layers
                    @validation.clearLayers()
                    # clear settings
                    @validation.settings = {}

            @scope.$on '$destroy', () =>
                @transitionStart()

    cleanup: () =>
        delete @scope.field_data

    validate: () =>
        @validation.setFieldData(@scope.field_data)

        return true

    toggleZone: (zone) =>
        # toggle
        zone.enabled = not zone.enabled
        # enable or disable steps
        if zone.enabled
            @enableZoneSteps(zone)
        else
            @disableZoneSteps(zone)


    enableZoneSteps: (zone) =>
        for step in zone.child_steps
            @scope.$parent.steps.enableStep(step)


    disableZoneSteps: (zone) =>
        for step in zone.child_steps
            @scope.$parent.steps.disableStep(step)

    buttonDisabled: (zone) =>
        # only previous crop button can currently be disabled
        return zone.name is 'Previous Crop' and @scope.field_data.zones['previous-crop'].has_existing
